
export enum EAS {
    /**
    * System Information et Repertoire des Entreprise et des Etablissements: SIRENE
    */
    SystemInformationEtRepertoireDesEntrepriseEtDesEtablissementsSirene = "0002",
    /**
    * Organisationsnummer
    */
    Organisationsnummer = "0007",
    /**
    * SIRET-CODE
    */
    SiretCode = "0009",
    /**
    * LY-tunnus
    */
    LyTunnus = "0037",
    /**
    * Data Universal Numbering System (D-U-N-S Number)
    */
    DataUniversalNumberingSystemDUNSNumber = "0060",
    /**
    * EAN Location Code
    */
    EanLocationCode = "0088",
    /**
    * DANISH CHAMBER OF COMMERCE Scheme (EDIRA compliant)
    */
    DanishChamberOfCommerceSchemeEdiraCompliant = "0096",
    /**
    * FTI - Ediforum Italia, (EDIRA compliant)
    */
    FtiEdiforumItaliaEdiraCompliant = "0097",
    /**
    * Vereniging van Kamers van Koophandel en Fabrieken in Nederland (Association of Chambers of Commerce and Industry in the Netherlands), Scheme (EDIRA compliant)
    */
    VerenigingVanKamersVanKoophandelEnFabriekenInNederlandAssociationChambersCommerceAndIndustryInNetherlandsSchemeEdiraCompliant = "0106",
    /**
    * Directorates of the European Commission
    */
    DirectoratesEuropeanCommission = "0130",
    /**
    * SIA Object Identifiers
    */
    SiaObjectIdentifiers = "0135",
    /**
    * SECETI Object Identifiers
    */
    SecetiObjectIdentifiers = "0142",
    /**
    * Standard Company Code
    */
    StandardCompanyCode = "0147",
    /**
    * Australian Business Number (ABN) Scheme
    */
    AustralianBusinessNumberAbnScheme = "0151",
    /**
    * Teikoku Company Code
    */
    TeikokuCompanyCode = "0170",
    /**
    * Odette International Limited 
    */
    OdetteInternationalLimited = "0177",
    /**
    * Numéro d'identification suisse des enterprises (IDE), Swiss Unique Business Identification Number (UIDB) 
    */
    NuméroDidentificationSuisseDesEnterprisesIdeSwissUniqueBusinessIdentificationNumberUidb = "0183",
    /**
    * DIGSTORG
    */
    Digstorg = "0184",
    /**
    * Corporate Number of The Social Security and Tax Number System
    */
    CorporateNumberTheSocialSecurityAndTaxNumberSystem = "0188",
    /**
    * Dutch Originator's Identification Number
    */
    DutchOriginatorsIdentificationNumber = "0190",
    /**
    * Centre of Registers and Information Systems of the Ministry of Justice
    */
    CentreRegistersAndInformationSystemsMinistryJustice = "0191",
    /**
    * Enhetsregisteret ved Bronnoysundregisterne 
    */
    EnhetsregisteretVedBronnoysundregisterne = "0192",
    /**
    * UBL.BE party identifier
    */
    UblBePartyIdentifier = "0193",
    /**
    * KOIOS Open Technical Dictionary
    */
    KoiosOpenTechnicalDictionary = "0194",
    /**
    * Singapore UEN identifier
    */
    SingaporeUenIdentifier = "0195",
    /**
    * Kennitala - Iceland legal id for individuals and legal entities
    */
    KennitalaIcelandLegalIdForIndividualsAndLegalEntities = "0196",
    /**
    * ERSTORG
    */
    Erstorg = "0198",
    /**
    * Global legal entity identifier (GLEIF)
    */
    GlobalLegalEntityIdentifierGleif = "0199",
    /**
    * Legal entity code (Lithuania)
    */
    LegalEntityCodeLithuania = "0200",
    /**
    * Codice Univoco Unità Organizzativa iPA
    */
    CodiceUnivocoUnitàOrganizzativaIpa = "0201",
    /**
    * Indirizzo di Posta Elettronica Certificata
    */
    IndirizzoDiPostaElettronicaCertificata = "0202",
    /**
    * eDelivery Network Participant identifier
    */
    EdeliveryNetworkParticipantIdentifier = "0203",
    /**
    * Leitweg-ID
    */
    LeitwegId = "0204",
    /**
    * CODDEST
    */
    Coddest = "0205",
    /**
    * Numero d'entreprise / ondernemingsnummer / Unternehmensnummer
    */
    NumeroDentrepriseOndernemingsnummerUnternehmensnummer = "0208",
    /**
    * GS1 identification keys
    */
    Gs1IdentificationKeys = "0209",
    /**
    * CODICE FISCALE
    */
    CodiceFiscale = "0210",
    /**
    * PARTITA IVA
    */
    PartitaIva = "0211",
    /**
    * Finnish Organization Identifier
    */
    FinnishOrganizationIdentifier = "0212",
    /**
    * Finnish Organization Value Add Tax Identifier
    */
    FinnishOrganizationValueAddTaxIdentifier = "0213",
    /**
    * Net service ID
    */
    NetServiceId = "0215",
    /**
    * OVTcode
    */
    Ovtcode = "0216",
    /**
    * The Netherlands Chamber of Commerce and Industry establishment number
    */
    TheNetherlandsChamberCommerceAndIndustryEstablishmentNumber = "0217",
    /**
    * Unified registration number (Latvia)
    */
    UnifiedRegistrationNumberLatvia = "0218",
    /**
    *  The registered number of the qualified invoice issuer
    */
    TheRegisteredNumberQualifiedInvoiceIssuer = "0221",
    /**
    *  FRCTC ELECTRONIC ADDRESS
    */
    FrctcElectronicAddress = "0225",
    /**
    *  National e-Invoicing Framework
    */
    NationalEInvoicingFramework = "0230",
    /**
    * UAE Tax Identification Number (TIN)
    */
    UaeTaxIdentificationNumberTin = "0235",
    /**
    * Danish Ministry of the Interior and Health
    */
    DanishMinistryInteriorAndHealth = "9901",
    /**
    * Hungary VAT number
    */
    HungaryVatNumber = "9910",
    /**
    * Business Registers Network 
    */
    BusinessRegistersNetwork = "9913",
    /**
    * Österreichische Umsatzsteuer-Identifikationsnummer 
    */
    ÖsterreichischeUmsatzsteuerIdentifikationsnummer = "9914",
    /**
    * Österreichisches Verwaltungs bzw. Organisationskennzeichen
    */
    ÖsterreichischesVerwaltungsBzwOrganisationskennzeichen = "9915",
    /**
    * SOCIETY FOR WORLDWIDE INTERBANK FINANCIAL, TELECOMMUNICATION S.W.I.F.T
    */
    SocietyForWorldwideInterbankFinancialTelecommunicationSWIFT = "9918",
    /**
    * Kennziffer des Unternehmensregisters 
    */
    KennzifferDesUnternehmensregisters = "9919",
    /**
    * Agencia Española de Administración Tributaria 
    */
    AgenciaEspañolaDeAdministraciónTributaria = "9920",
    /**
    * Andorra VAT number
    */
    AndorraVatNumber = "9922",
    /**
    * Albania VAT number
    */
    AlbaniaVatNumber = "9923",
    /**
    * Bosnia and Herzegovina VAT number
    */
    BosniaAndHerzegovinaVatNumber = "9924",
    /**
    * Belgium VAT number
    */
    BelgiumVatNumber = "9925",
    /**
    * Bulgaria VAT number
    */
    BulgariaVatNumber = "9926",
    /**
    * Switzerland VAT number
    */
    SwitzerlandVatNumber = "9927",
    /**
    * Cyprus VAT number
    */
    CyprusVatNumber = "9928",
    /**
    * Czech Republic VAT number
    */
    CzechRepublicVatNumber = "9929",
    /**
    * Germany VAT number
    */
    GermanyVatNumber = "9930",
    /**
    * Estonia VAT number
    */
    EstoniaVatNumber = "9931",
    /**
    * United Kingdom VAT number
    */
    UnitedKingdomVatNumber = "9932",
    /**
    * Greece VAT number
    */
    GreeceVatNumber = "9933",
    /**
    * Croatia VAT number
    */
    CroatiaVatNumber = "9934",
    /**
    * Ireland VAT number
    */
    IrelandVatNumber = "9935",
    /**
    * Liechtenstein VAT number
    */
    LiechtensteinVatNumber = "9936",
    /**
    * Lithuania VAT number
    */
    LithuaniaVatNumber = "9937",
    /**
    * Luxemburg VAT number
    */
    LuxemburgVatNumber = "9938",
    /**
    * Latvia VAT number
    */
    LatviaVatNumber = "9939",
    /**
    * Monaco VAT number
    */
    MonacoVatNumber = "9940",
    /**
    * Montenegro VAT number
    */
    MontenegroVatNumber = "9941",
    /**
    * Macedonia, the former Yugoslav Republic of VAT number
    */
    MacedoniaFormerYugoslavRepublicVatNumber = "9942",
    /**
    * Malta VAT number
    */
    MaltaVatNumber = "9943",
    /**
    * Netherlands VAT number
    */
    NetherlandsVatNumber = "9944",
    /**
    * Poland VAT number
    */
    PolandVatNumber = "9945",
    /**
    * Portugal VAT number
    */
    PortugalVatNumber = "9946",
    /**
    * Romania VAT number
    */
    RomaniaVatNumber = "9947",
    /**
    * Serbia VAT number
    */
    SerbiaVatNumber = "9948",
    /**
    * Slovenia VAT number
    */
    SloveniaVatNumber = "9949",
    /**
    * Slovakia VAT number
    */
    SlovakiaVatNumber = "9950",
    /**
    * San Marino VAT number
    */
    SanMarinoVatNumber = "9951",
    /**
    * Turkey VAT number
    */
    TurkeyVatNumber = "9952",
    /**
    * Holy See (Vatican City State) VAT number
    */
    HolySeeVaticanCityStateVatNumber = "9953",
    /**
    * French VAT number
    */
    FrenchVatNumber = "9957",
    /**
    * Employer Identification Number (EIN, USA)
    */
    EmployerIdentificationNumberEinUsa = "9959",
    /**
    * O.F.T.P. (ODETTE File Transfer Protocol)
    */
    OFTPOdetteFileTransferProtocol = "AN",
    /**
    * X.400 address for mail text
    */
    X400AddressForMailText = "AQ ",
    /**
    * AS2 exchange 
    */
    As2Exchange = "AS ",
    /**
    * File Transfer Protocol
    */
    FileTransferProtocol = "AU ",
    /**
    * Electronic mail (SMPT)
    */
    ElectronicMailSmpt = "EM",
}

export function description(value: EAS): string {
    switch (value) {
        case EAS.SystemInformationEtRepertoireDesEntrepriseEtDesEtablissementsSirene: return "System Information et Repertoire des Entreprise et des Etablissements: SIRENE";
        case EAS.Organisationsnummer: return "Organisationsnummer";
        case EAS.SiretCode: return "SIRET-CODE";
        case EAS.LyTunnus: return "LY-tunnus";
        case EAS.DataUniversalNumberingSystemDUNSNumber: return "Data Universal Numbering System (D-U-N-S Number)";
        case EAS.EanLocationCode: return "EAN Location Code";
        case EAS.DanishChamberOfCommerceSchemeEdiraCompliant: return "DANISH CHAMBER OF COMMERCE Scheme (EDIRA compliant)";
        case EAS.FtiEdiforumItaliaEdiraCompliant: return "FTI - Ediforum Italia, (EDIRA compliant)";
        case EAS.VerenigingVanKamersVanKoophandelEnFabriekenInNederlandAssociationChambersCommerceAndIndustryInNetherlandsSchemeEdiraCompliant: return "Vereniging van Kamers van Koophandel en Fabrieken in Nederland (Association of Chambers of Commerce and Industry in the Netherlands), Scheme (EDIRA compliant)";
        case EAS.DirectoratesEuropeanCommission: return "Directorates of the European Commission";
        case EAS.SiaObjectIdentifiers: return "SIA Object Identifiers";
        case EAS.SecetiObjectIdentifiers: return "SECETI Object Identifiers";
        case EAS.StandardCompanyCode: return "Standard Company Code";
        case EAS.AustralianBusinessNumberAbnScheme: return "Australian Business Number (ABN) Scheme";
        case EAS.TeikokuCompanyCode: return "Teikoku Company Code";
        case EAS.OdetteInternationalLimited: return "Odette International Limited ";
        case EAS.NuméroDidentificationSuisseDesEnterprisesIdeSwissUniqueBusinessIdentificationNumberUidb: return "Numéro d'identification suisse des enterprises (IDE), Swiss Unique Business Identification Number (UIDB) ";
        case EAS.Digstorg: return "DIGSTORG";
        case EAS.CorporateNumberTheSocialSecurityAndTaxNumberSystem: return "Corporate Number of The Social Security and Tax Number System";
        case EAS.DutchOriginatorsIdentificationNumber: return "Dutch Originator's Identification Number";
        case EAS.CentreRegistersAndInformationSystemsMinistryJustice: return "Centre of Registers and Information Systems of the Ministry of Justice";
        case EAS.EnhetsregisteretVedBronnoysundregisterne: return "Enhetsregisteret ved Bronnoysundregisterne ";
        case EAS.UblBePartyIdentifier: return "UBL.BE party identifier";
        case EAS.KoiosOpenTechnicalDictionary: return "KOIOS Open Technical Dictionary";
        case EAS.SingaporeUenIdentifier: return "Singapore UEN identifier";
        case EAS.KennitalaIcelandLegalIdForIndividualsAndLegalEntities: return "Kennitala - Iceland legal id for individuals and legal entities";
        case EAS.Erstorg: return "ERSTORG";
        case EAS.GlobalLegalEntityIdentifierGleif: return "Global legal entity identifier (GLEIF)";
        case EAS.LegalEntityCodeLithuania: return "Legal entity code (Lithuania)";
        case EAS.CodiceUnivocoUnitàOrganizzativaIpa: return "Codice Univoco Unità Organizzativa iPA";
        case EAS.IndirizzoDiPostaElettronicaCertificata: return "Indirizzo di Posta Elettronica Certificata";
        case EAS.EdeliveryNetworkParticipantIdentifier: return "eDelivery Network Participant identifier";
        case EAS.LeitwegId: return "Leitweg-ID";
        case EAS.Coddest: return "CODDEST";
        case EAS.NumeroDentrepriseOndernemingsnummerUnternehmensnummer: return "Numero d'entreprise / ondernemingsnummer / Unternehmensnummer";
        case EAS.Gs1IdentificationKeys: return "GS1 identification keys";
        case EAS.CodiceFiscale: return "CODICE FISCALE";
        case EAS.PartitaIva: return "PARTITA IVA";
        case EAS.FinnishOrganizationIdentifier: return "Finnish Organization Identifier";
        case EAS.FinnishOrganizationValueAddTaxIdentifier: return "Finnish Organization Value Add Tax Identifier";
        case EAS.NetServiceId: return "Net service ID";
        case EAS.Ovtcode: return "OVTcode";
        case EAS.TheNetherlandsChamberCommerceAndIndustryEstablishmentNumber: return "The Netherlands Chamber of Commerce and Industry establishment number";
        case EAS.UnifiedRegistrationNumberLatvia: return "Unified registration number (Latvia)";
        case EAS.TheRegisteredNumberQualifiedInvoiceIssuer: return " The registered number of the qualified invoice issuer";
        case EAS.FrctcElectronicAddress: return " FRCTC ELECTRONIC ADDRESS";
        case EAS.NationalEInvoicingFramework: return " National e-Invoicing Framework";
        case EAS.UaeTaxIdentificationNumberTin: return "UAE Tax Identification Number (TIN)";
        case EAS.DanishMinistryInteriorAndHealth: return "Danish Ministry of the Interior and Health";
        case EAS.HungaryVatNumber: return "Hungary VAT number";
        case EAS.BusinessRegistersNetwork: return "Business Registers Network ";
        case EAS.ÖsterreichischeUmsatzsteuerIdentifikationsnummer: return "Österreichische Umsatzsteuer-Identifikationsnummer ";
        case EAS.ÖsterreichischesVerwaltungsBzwOrganisationskennzeichen: return "Österreichisches Verwaltungs bzw. Organisationskennzeichen";
        case EAS.SocietyForWorldwideInterbankFinancialTelecommunicationSWIFT: return "SOCIETY FOR WORLDWIDE INTERBANK FINANCIAL, TELECOMMUNICATION S.W.I.F.T";
        case EAS.KennzifferDesUnternehmensregisters: return "Kennziffer des Unternehmensregisters ";
        case EAS.AgenciaEspañolaDeAdministraciónTributaria: return "Agencia Española de Administración Tributaria ";
        case EAS.AndorraVatNumber: return "Andorra VAT number";
        case EAS.AlbaniaVatNumber: return "Albania VAT number";
        case EAS.BosniaAndHerzegovinaVatNumber: return "Bosnia and Herzegovina VAT number";
        case EAS.BelgiumVatNumber: return "Belgium VAT number";
        case EAS.BulgariaVatNumber: return "Bulgaria VAT number";
        case EAS.SwitzerlandVatNumber: return "Switzerland VAT number";
        case EAS.CyprusVatNumber: return "Cyprus VAT number";
        case EAS.CzechRepublicVatNumber: return "Czech Republic VAT number";
        case EAS.GermanyVatNumber: return "Germany VAT number";
        case EAS.EstoniaVatNumber: return "Estonia VAT number";
        case EAS.UnitedKingdomVatNumber: return "United Kingdom VAT number";
        case EAS.GreeceVatNumber: return "Greece VAT number";
        case EAS.CroatiaVatNumber: return "Croatia VAT number";
        case EAS.IrelandVatNumber: return "Ireland VAT number";
        case EAS.LiechtensteinVatNumber: return "Liechtenstein VAT number";
        case EAS.LithuaniaVatNumber: return "Lithuania VAT number";
        case EAS.LuxemburgVatNumber: return "Luxemburg VAT number";
        case EAS.LatviaVatNumber: return "Latvia VAT number";
        case EAS.MonacoVatNumber: return "Monaco VAT number";
        case EAS.MontenegroVatNumber: return "Montenegro VAT number";
        case EAS.MacedoniaFormerYugoslavRepublicVatNumber: return "Macedonia, the former Yugoslav Republic of VAT number";
        case EAS.MaltaVatNumber: return "Malta VAT number";
        case EAS.NetherlandsVatNumber: return "Netherlands VAT number";
        case EAS.PolandVatNumber: return "Poland VAT number";
        case EAS.PortugalVatNumber: return "Portugal VAT number";
        case EAS.RomaniaVatNumber: return "Romania VAT number";
        case EAS.SerbiaVatNumber: return "Serbia VAT number";
        case EAS.SloveniaVatNumber: return "Slovenia VAT number";
        case EAS.SlovakiaVatNumber: return "Slovakia VAT number";
        case EAS.SanMarinoVatNumber: return "San Marino VAT number";
        case EAS.TurkeyVatNumber: return "Turkey VAT number";
        case EAS.HolySeeVaticanCityStateVatNumber: return "Holy See (Vatican City State) VAT number";
        case EAS.FrenchVatNumber: return "French VAT number";
        case EAS.EmployerIdentificationNumberEinUsa: return "Employer Identification Number (EIN, USA)";
        case EAS.OFTPOdetteFileTransferProtocol: return "O.F.T.P. (ODETTE File Transfer Protocol)";
        case EAS.X400AddressForMailText: return "X.400 address for mail text";
        case EAS.As2Exchange: return "AS2 exchange ";
        case EAS.FileTransferProtocol: return "File Transfer Protocol";
        case EAS.ElectronicMailSmpt: return "Electronic mail (SMPT)";
    }
}
